"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _card = require("./card.style");
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
const Card = /*#__PURE__*/(0, _react.forwardRef)((props, ref) => {
  const {
      fit = 'medium',
      loading = false,
      imagesrc,
      imagebackgroundcolor = 'rgba(247,247,247,1)',
      imagescalestrength = 'light',
      imagepercent = 0,
      subHeading = 'Card Sub Heading',
      heading = 'Card Heading',
      href,
      body = 'Some quick example text to build on the card title and make up the bulk of the card content.',
      footer,
      orientation = 'vertical',
      variant = 'bordered',
      padding,
      customisedContent = false,
      rel,
      target
    } = props,
    rest = __rest(props, ["fit", "loading", "imagesrc", "imagebackgroundcolor", "imagescalestrength", "imagepercent", "subHeading", "heading", "href", "body", "footer", "orientation", "variant", "padding", "customisedContent", "rel", "target"]);
  return (0, _jsxRuntime.jsx)(_card.Components.CardWrapper, (0, _extends2["default"])({
    variant: variant,
    orientation: orientation,
    padding: padding,
    imagescalestrength: imagescalestrength,
    ref: ref,
    as: href && href.length > 0 ? 'a' : 'div',
    href: href,
    rel: rel,
    target: target
  }, rest, {
    children: loading ? (0, _jsxRuntime.jsx)(_card.Components.CardLoadingIndicator, {}) : (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [imagesrc && (0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
        children: typeof imagesrc === 'string' ? (0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
          children: (0, _jsxRuntime.jsx)(_card.Components.ImageArea, {
            className: "imageDiv",
            imagesrc: imagesrc,
            imagepercent: isNaN(imagepercent) ? undefined : imagepercent,
            imagebackgroundcolor: imagebackgroundcolor,
            imagescalestrength: imagescalestrength,
            orientation: orientation,
            variant: variant
          })
        }) : (0, _jsxRuntime.jsx)(_card.Components.ImageWrapper, {
          children: imagesrc
        })
      }), customisedContent ? (0, _jsxRuntime.jsx)(_card.Components.TextAndButtonArea, {
        children: customisedContent
      }) : (0, _jsxRuntime.jsx)(_card.Components.TextAndButtonArea, (0, _extends2["default"])({
        fit: fit,
        variant: variant,
        orientation: orientation,
        padding: padding
      }, {
        children: (0, _jsxRuntime.jsxs)(_card.Components.TextArea, {
          children: [subHeading && (0, _jsxRuntime.jsx)(_card.Components.SubHeading, (0, _extends2["default"])({
            fit: fit
          }, {
            children: subHeading
          })), heading && (0, _jsxRuntime.jsx)(_card.Components.Heading, (0, _extends2["default"])({
            fit: fit
          }, {
            children: heading
          })), body && (0, _jsxRuntime.jsx)(_card.Components.Body, (0, _extends2["default"])({
            fit: fit
          }, {
            children: body
          })), footer && (0, _jsxRuntime.jsx)(_card.Components.Footer, (0, _extends2["default"])({
            fit: fit
          }, {
            children: footer
          }))]
        })
      }))]
    })
  }));
});
var _default = exports["default"] = Card;